import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Stack from '@mui/material/Stack'

import { useQuery } from '~/client/hooks/cqrpc'
import { useCurrentUser } from '~/client/hooks/auth'
import ErrorMessage from '~/client/components/ErrorMessage'
import Heading from '~/client/components/Heading'
import SideNote from '~/client/components/SideNote'
import Timestamp from '~/client/components/Timestamp'
import AppIconAndName from '~/client/components/AppIconAndName'
import Link from '~/client/components/Link'
import AppIcon from '~/client/components/AppIcon'
import StarOutlineIcon from '@mui/icons-material/StarOutline'
import StarRateIcon from '@mui/icons-material/StarRate';

export default function AppConnectionsPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const query = useQuery('appAccounts.getMine')
  return <Container>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Heading my={2} variant="main">Connections</Heading>
    </Stack>
    <SideNote>
      Connections are the third-parties with which you agree to share some or 
      all of your information. They can be: Apps that you use; Organisations 
      who you allow to market to you; other data services that are useful to 
      you. Here you can see those connections that you already have in place. ​
    </SideNote>
    <Box sx={{ borderBottom: 1, borderColor: 'divider', my: 2, maxWidth: '75vw' }}>
      <Tabs value={value} onChange={handleChange}>
          <Tab label="My Connections" {...allyProps(0)} />
          <Tab label="Available Connections" {...allyProps(1)} />
      </Tabs>
    </Box>
    <TabPanel value={value} index={0}>
      <MyConnectionList />
    </TabPanel>
    <TabPanel value={value} index={1}>
      <AvailableConnectionList/>
    </TabPanel>
  </Container>
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function allyProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function MyConnectionList() {
  const query = useQuery('appAccounts.getMine')
  const connections = query.result || []
  return <>
    <ErrorMessage error={query.error}/>
    <TableContainer sx={{maxWidth: '75vw'}}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Connection</TableCell>
            <TableCell>Type</TableCell>
            <TableCell align="right">Data Blocks Shared</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{
          '&:last-child td, &:last-child th': {
            border: 0
          }
        }}>
          {connections.map(connection => (
            <TableRow>
              <TableCell sx={{p: 1}}>
                <Link to={`/connections/${connection.app.host}`}>
                  <AppIcon app={connection.app} size = 'sm'/>
                  {connection.app.name}
                </Link>
              </TableCell>
              <TableCell sx={{p: 1}}>
                {connection.app.type}
              </TableCell>
              <TableCell sx={{p: 1, overflow: 'scroll'}} align="right">
                {connection.blocksShared}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
}

function AvailableConnectionList() {
  const query = useQuery('apps.getPublic')
  const apps = query.result || []
  return <>
    <ErrorMessage error={query.error}/>
    <TableContainer>
      <Table sx={{maxWidth: '75vw'}}>
        <TableHead>
          <TableRow>
            <TableCell>Connection</TableCell>
            <TableCell>Type</TableCell>
            <TableCell align="right">Average Rating</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{
          '&:last-child td, &:last-child th': {
            border: 0
          }
        }}>
          {apps.map(app => (
            <TableRow>
              <TableCell sx={{p: 1}}>
                <Link to={`/connections/${app.host}`}>
                  <AppIcon app={app} size = 'sm'/>
                  {app.name}
                </Link>
              </TableCell>
              <TableCell sx={{p: 1}}>
                {app.type}
              </TableCell>
              <TableCell align="right" sx={{p: 1}}>
                <StarRateIcon/><StarRateIcon/><StarRateIcon/><StarOutlineIcon/><StarOutlineIcon/>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
}

